import { useQuery, UseQueryOptions } from "react-query";

import { mapAriseFeeTemplateDataFromServer } from "mappers";
import { feeTemplateService } from "services";

type UseGetAriseFeeTemplateQueryProps = {
	companyId: string;
	templateId: string;
	options?:
		| Omit<
				UseQueryOptions<any, unknown, any, string[]>,
				"queryKey" | "queryFn"
		  >
		| undefined;
};

const useGetAriseFeeTemplateQuery = ({
	companyId,
	templateId,
	options,
}: UseGetAriseFeeTemplateQueryProps) => {
	return useQuery(
		["getAchFeeTemplate", companyId, templateId],
		() => feeTemplateService.ariseFeeTemplateGet({ companyId, templateId }),
		{
			select: data => mapAriseFeeTemplateDataFromServer(data),
			enabled: !!companyId && !!templateId,
			...options,
		},
	);
};

export default useGetAriseFeeTemplateQuery;
